import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const deposcoSettings = defineIntegrationSettings({
  fields: {
    businessUnit: z.string().trim().min(1, "Business unit is required"),
  },
  secrets: {},
  connectOnly: {
    refreshToken: z.string().trim().min(1, "Refresh token is required"),
  },
  computed: { lastSyncTime: z.date().nullable() },
});
